import React from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactAnimation from 'shared/design-system/base/TrueImpactAnimation';
import styled from 'styled-components';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { SectionBase } from '../SectionBase';
import StageCard from './StageCard';
import { Button } from '../../styles';
import { GuidanceTextResponse } from '../utils';

interface IntroProps {
  name?: string;
  subTitle?: object;
  title?: object;
  helpText?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
  questionId?: string;
  value?: string;
  onChange?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cardContent?: any;
  key: number;
  guidanceText: GuidanceTextResponse;
  onNextSection: () => unknown;
}

const cardContent = [
  {
    stageName: 'Program Start',
    stageDate: 'Today',
    stageDesc: `This is the core of your report. Together, we will make sure all the
    details of your amazing program are correct, and you’ll forecast the
    results of your program, as well.`,
    stageTime: `This stage will take the longest to complete — generally 30 minutes
    to an hour.`,
  },
  {
    stageName: 'Program Midpoint',
    stageDate: 'July 17, 2022',
    stageDesc: `We will check in at your program’s midway point to make any
    adjustments and check to see if you’re on track to hit your
    forecasts you made when you completed the Program Start stage.`,
    stageTime: `This stage shouldn’t take more than a few minutes to complete
    (assuming no major updates).`,
  },
  {
    stageName: 'Program End',
    stageDate: 'December 31, 2022',
    stageDesc: `Finally, we will compare your final results to your original and
    midpoint forecasts and make any final adjustments before your
    report is submitted for feedback from True Impact (and possibly
    your donor).`,
    stageTime: 'This stage should take about 15 minutes.',
  },
];

const intro1Title = () => {
  return (
    <>
      <TrueImpactAnimation variant="appear" animationDelay={2}>
        <TrueImpactText variant="heading-page" align="center">
          Hi Megan!
        </TrueImpactText>
      </TrueImpactAnimation>
      <TrueImpactAnimation variant="appear" animationDelay={3}>
        <TrueImpactText variant="heading-page" align="center">
          We are True Impact’s client success team, and we are here to help you
          create you program’s report.
        </TrueImpactText>
      </TrueImpactAnimation>
    </>
  );
};
const intro1TitleContent = intro1Title();

const intro2Title = () => {
  return (
    <>
      <TrueImpactAnimation variant="appear" animationDelay={2}>
        <TrueImpactText variant="heading-page" align="center">
          Great!
        </TrueImpactText>
      </TrueImpactAnimation>
      <TrueImpactAnimation variant="appear" animationDelay={3}>
        <TrueImpactText variant="heading-page" align="center">
          Before we get started, here is what to expect.
        </TrueImpactText>
      </TrueImpactAnimation>
    </>
  );
};
const intro2TitleContent = intro2Title();
const intro2HelpTextContent = 'Your report consists of three crucial checkpoints or stages:';

const introHelpText = 'This is some help text';

const Intro: React.FC<IntroProps> = ({
  title,
  subTitle,
  helpText,
  guidanceText,
  error,
  onNextSection,
  questionId,
  value,
  onChange,
}) => {
  return (
    <SectionBase
      subTitle={intro2TitleContent}
      error={error}
      helpText={intro2HelpTextContent}
      title={undefined}
      questionId={questionId}
      guidanceText={guidanceText}
    >
      <CardStageContainer>
        {cardContent.map((card, index) => {
          return (
            <TrueImpactAnimation animationDelay={(index + 1) * 8}>
              <StageCard
                key={index}
                index={index}
                stageName={card.stageName}
                stageDate={card.stageDate}
                stageDesc={card.stageDesc}
                stageTime={card.stageTime}
              />
            </TrueImpactAnimation>
          );
        })}
      </CardStageContainer>
      <TrueImpactAnimation variant="appear" animationDelay={32}>
        <TrueImpactText variant="body" align="center" className="">
          We will send you an email at each of these stages to let you know it’s
          time to update your report.
        </TrueImpactText>
      </TrueImpactAnimation>
      <TrueImpactAnimation>
        <ButtonContainer>
          <TrueImpactAnimation variant="appear" animationDelay={40}>
            <Button onClick={onNextSection}>Let's Go!</Button>
          </TrueImpactAnimation>
        </ButtonContainer>
      </TrueImpactAnimation>
    </SectionBase>
  );
};

const CardStageContainer = styled.div`
  display: flex;
  margin-bottom: ${SPACERS.large};
  justify-content: center;
  gap: ${SPACERS.medium};
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: ${SPACERS.extraLarge} auto 80px;
`;

export default Intro;
